
/**
 * 过滤银行卡号
 * @param value
 * @returns {string|*}
 */
export default (value) => {
    if (value === undefined || value === null || value === '' || typeof value === Object) {
        return ''
    }

    let text = '';
    try {
        text = value.slice(0, 4) + "********" + value.slice(value.length - 4, value.length)
    } catch (e) {

    }

    return text
}



// WEBPACK FOOTER //
// ./src/static/js/utils/modules/filterYhkh.js